/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BvnVerificationStatusDTO } from './BvnVerificationStatusDTO';
import type { SelfieVerificationStatusDTO } from './SelfieVerificationStatusDTO';

export type UtilityVerificationStatusResponseDTO = {
    attemptsRemaining?: number;
    bvnStatus?: BvnVerificationStatusDTO;
    combinedStatus?: string;
    jobId?: string;
    selfieStatus?: SelfieVerificationStatusDTO;
    timedOut?: boolean;
    verificationType?: UtilityVerificationStatusResponseDTO.verificationType;
};

export namespace UtilityVerificationStatusResponseDTO {

    export enum verificationType {
        BVN_VERIFICATION = 'BVN_VERIFICATION',
        SELFIE_VERIFICATION = 'SELFIE_VERIFICATION',
        COMBINED_VERIFICATION = 'COMBINED_VERIFICATION',
    }


}
